import { render, staticRenderFns } from "./roleManageForm.vue?vue&type=template&id=559f234a&"
import script from "./roleManageForm.vue?vue&type=script&lang=js&"
export * from "./roleManageForm.vue?vue&type=script&lang=js&"
import style0 from "./roleManageForm.vue?vue&type=style&index=0&id=559f234a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports